import request from '../utils/request'

// 个人信息查询
export const loginInfo = () => {
  return request({
    url: '/buyer/login/info',
    method: 'GET'
  })
}
// 注册请求
export const register = (data) => {
  return request({
    url: '/buyer/login/register',
    method: 'POST',
    data
  })
}
// 登录请求
export const login = (data) => {
  return request({
    url: '/buyer/login/login',
    method: 'POST',
    data
  })
}
// 发送验证码
export const phonecode = (data) => {
  return request({
    url: '/buyer/forget/password/phonecode/generate',
    method: 'POST',
    data
  })
}
// 修改密码
export const setPassword = (data) => {
  return request({
    url: '/buyer/forget/password',
    method: 'POST',
    data
  })
}

// 获取协议
export const protocolDetail = (params) => {
  return request({
    url: '/common/protocol/detail',
    method: 'get',
    params
  })
}
